import { expand } from 'uri-template-lite';
import { ApiError, apiClient } from '../../../common/ApiClient';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';
import { SampleEditSessionUrl } from '../SampleEditSessionUrl';

interface ValidateSampleRowRequest {
  sessionId: string;
  payload: unknown;
}

// validate-row returns the same ApiError shape the rest of the app already renders; empty array = valid.
const validateSampleRow = async ({
  sessionId,
  payload,
}: ValidateSampleRowRequest): Promise<ApiError[]> =>
  apiClient
    .post(expand(SampleEditSessionUrl.validateRow, { sessionId }), payload)
    .then((response) => response.data);

export const useValidateSampleRowMutation = createApiMutationHook<
  ValidateSampleRowRequest,
  ApiError[]
>(['sample-row-validate'], validateSampleRow);
